import { ApolloClient, createHttpLink, InMemoryCache, from } from '@apollo/client';
import type { IStore } from '../types';
import { createAuthLink, createErrorLink } from './links';
import type { StoreDispatch } from './types';

interface ClientWithStore extends ApolloClient<unknown> {
  updateStore: (store: IStore) => void;
}

export const createApolloClient = (
  dispatch: StoreDispatch,
  apiUrl: string,
  apiKey?: string
): ClientWithStore => {
  const initialStore: IStore = { 
    isAuthenticated: false, 
    user: null, 
    token: null, 
    refreshToken: null 
  };
  
  const store = { current: initialStore };
  
  const getStore = () => store.current;

  const httpLink = createHttpLink({ uri: apiUrl });
  const authLink = createAuthLink(getStore, apiKey);
  const errorLink = createErrorLink(getStore, dispatch, apiUrl, apiKey);

  const client = new ApolloClient({
    link: from([errorLink, authLink, httpLink]),
    cache: new InMemoryCache(),
  });

  const updateStore = (newStore: IStore) => {
    store.current = newStore;
  };

  return Object.assign(client, { updateStore });
};
